import { reports } from "./reports";
import { tableColumnTypes } from "../../tableColumnTypes";
import { FormattedMessage } from "react-intl";

export const accessModalReport = {
  label: <FormattedMessage id="ACCESS_REPORT" />,
  path: (tenantName) => `/${tenantName}/reports/accessReport`,

  columns: (navigate) => [
    {
      ID: 1,
      name: <FormattedMessage id="LOGIN_NO" />,
      fieldName: "LoginId",
      value: (row) => row.LoginId,
      // sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 2,
      name: <FormattedMessage id="LOGIN_DATE" />,
      fieldName: "LoginDate",
      value: (row) => row.LoginDate,
      // sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 3,
      name: <FormattedMessage id="LOGIN_TIME" />,
      fieldName: "LoginTime",
      value: (row) => row.LoginTime,
      // sort: true,
      type: tableColumnTypes.STRING,
    },
  ],
};

export const aadAccessModalReport = {
  label: <FormattedMessage id="ACCESS_REPORT" />,
  path: (tenantName) => `/${tenantName}/reports/accessReport`,

  aadAccessModalReportColumns: (navigate) => [
    {
      ID: 1,
      name: <FormattedMessage id="LOGIN_NO" />,
      fieldName: "LoginDate",
      value: (row, index) => index + 1,
      // sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 2,
      name: <FormattedMessage id="LOGIN_DATE" />,
      fieldName: "LoginDate",
      value: (index) => index,
      // sort: true,
      type: tableColumnTypes.DATE,
    },
  ],
};
